import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { STReq, STRes, STPage, STComponent, STColumn } from '@delon/abc';
import { NzModalRef } from 'ng-zorro-antd';
import { URLS } from '../../constant/interface';

@Component({
  selector: 'app-smart-group',
  templateUrl: './smart-group.component.html',
  styles: [],
})
export class SmartGroupComponent implements OnInit, AfterViewInit {
  constructor(private modal: NzModalRef) {}
  title = '获取智能客群条件';
  subject = '获取智能客群条件';
  conditions: any;
  initConditions: any;
  msgType: string;
  msgTypes: [];
  carrierId: number;
  url = URLS.biztypeSmartGroup.url;
  req: STReq = {
    type: 'page',
    method: 'POST',
    allInBody: true,
    lazyLoad: true,
  };

  res: STRes = {
    process: (data, rawData) => {
      return data;
    },
  };
  page: STPage = {
    show: true,
  };
  @ViewChild('st', { static: false }) st: STComponent;
  columns: STColumn[] = [
    {
      title: '编号',
      index: 'selected',
      type: 'checkbox',
    },
    {
      title: '智能客群名称',
      index: 'name',
    },
    {
      title: '客群人数',
      index: 'custoCount',
    },
    {
      title: '执行条件',
      format: (item, _col, index) => {
        let condition = '';
        item.conditionList.forEach(meta => {
          if (condition.length === 0) {
            condition += meta.name + '---';
          } else {
            condition += '<br />' + meta.name + '---';
          }
          meta.value.forEach(tag => {
            condition += tag + ',';
          });
          condition = condition.substring(0, condition.length - 1);
        });
        return condition;
      },
    },
  ];

  ngOnInit() {}

  confirm() {
    // 处理数据格式
    let conditionsTemp = [];
    if (this.initConditions) {
      this.initConditions.forEach(element => {
        conditionsTemp.push(element);
      });
    }
    this.conditions.forEach(element => {
      element.conditionList.forEach(cd => {
        cd.bindObj = cd.object;
        let reCondition = conditionsTemp.find(cdt => cdt.name === cd.name);
        if (reCondition) {
          conditionsTemp.forEach(cdt => {
            if (cd.name === cdt.name) {
              cdt.value.forEach(vat => {
                cd.value.forEach(va => {
                  if (va !== vat && !cdt.value.find(v => v === va)) {
                    cdt.value.push(va);
                  }
                });
              });
            }
          });
        } else {
          conditionsTemp.push(cd);
        }
      });
    });
    this.modal.close(conditionsTemp);
  }

  cancel() {
    this.modal.triggerCancel();
  }

  ngAfterViewInit() {
    this.st.load();
    this.st.change.subscribe(e => {
      this.conditions = e.checkbox;
    });
  }
}
